import React from "react";

import {
  Button,
  IconButton,
  Icons,
  PanelModal,
  Text,
} from "@pushpress/shared-components";

export interface SetupAvailabilityModalProps {
  userUuid?: string;
  message?: string;
  loading?: boolean;
  visible: boolean;
  onClose: VoidFunction;
  onSendClick: (userUuid: string) => void;
}

function SetupAvailabilityModal(props: SetupAvailabilityModalProps) {
  const { visible, onClose } = props;

  return (
    <PanelModal visible={visible} width="380px" closeModal={onClose}>
      <SetupAvailabilityModalContent {...props} />
    </PanelModal>
  );
}

function SetupAvailabilityModalContent(props: SetupAvailabilityModalProps) {
  const { message, onSendClick, onClose, userUuid, loading } = props;

  return (
    <>
      <PanelModal.Body>
        <IconButton icon={Icons.X} onClick={onClose} />
        <Text variant="heading-4" color="wolf-800" className="mt-3">
          {message}
        </Text>
        <Button
          text="Send a reminder"
          buttonType="primary"
          fullWidth
          type="button"
          loading={loading}
          className="mt-4"
          size="large"
          onClick={() => onSendClick(userUuid)}
        />
        <Button
          component="a"
          text="Setup now"
          buttonType="text"
          fullWidth
          type="button"
          className="mt-2"
          size="large"
          href={`appointments/working-hours/${userUuid}`}
          target="_blank"
        />
      </PanelModal.Body>
    </>
  );
}

export default SetupAvailabilityModal;
